const data: any = [{"key":"paywalls-title","copy":"Before you can transfer funds..."},{"key":"paywalls-title","copy":"Before you can perform this function","brand":"netspendbusiness"}];
export default data